// extracted by mini-css-extract-plugin
export default {"column":"Column_column__D+YC7","title":"Column_title__HJV1B","icon":"Column_icon__XS9hb","cards":"Column_cards__NuWR5"};